import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$3, i as injectJwPlayerStatic } from './p-Cjwl5Ycq.js';
import { d as defineCustomElement$4 } from './p-Dr61d_nc.js';
import { d as defineCustomElement$2 } from './p-A4L-SdxG.js';
import { d as defineCustomElement$1 } from './p-D-dZjG8L.js';

const WuiJwPlayerBaseInjector = /*@__PURE__*/ proxyCustomElement(class WuiJwPlayerBaseInjector extends H {
    constructor() {
        super();
        this.__registerHost();
        /**
         * Player version
         */
        this.playerVersion = '';
        /**
         * Player license key
         */
        this.playerLicenseKey = '';
        /**
         * JW Player API
         */
        this.jwPlayerStatic = undefined;
        /**
         * If player is loading
         */
        this.playerLoading = true;
        /**
         * Internal player error
         */
        this.playerError = undefined;
    }
    componentWillLoad() {
        (async () => {
            try {
                const jwPlayerStatic = await injectJwPlayerStatic(this.playerVersion, this.playerLicenseKey);
                this.jwPlayerStatic = jwPlayerStatic;
                this.playerError = undefined;
            }
            catch (err) {
                this.playerError = err instanceof Error ? err : new Error(String(err));
            }
        })();
    }
    render() {
        return (h(Host, { key: '15f953b167f6ffd711b2c3891275361f33959b30', class: "jw-player-base-injector", style: { flex: '1' } }, this.jwPlayerStatic && (h("wui-jw-player-base-injector-container", { key: 'e94688edc69e8aa64d12358adfafec73283871c9', jwPlayerStatic: this.jwPlayerStatic, playerOptions: this.playerOptions, onPlayerSetup: () => {
                this.playerLoading = false;
            } })), h("wui-jw-player-base-overlay", { key: 'd190612694580327e4db26ba0b5d8d8e21a95b5c', visible: !!(this.playerError || this.playerLoading), error: this.playerError, loading: this.playerLoading, loadingText: "Player is loading" })));
    }
}, [256, "wui-jw-player-base-injector", {
        "playerVersion": [1, "player-version"],
        "playerLicenseKey": [1, "player-license-key"],
        "playerOptions": [16, "player-options"],
        "jwPlayerStatic": [32],
        "playerLoading": [32],
        "playerError": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-jw-player-base-injector", "wui-icon", "wui-jw-player-base-injector-container", "wui-jw-player-base-overlay", "wui-loader"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-jw-player-base-injector":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiJwPlayerBaseInjector);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-jw-player-base-injector-container":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-jw-player-base-overlay":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiJwPlayerBaseInjector as W, defineCustomElement as d };
